module.exports = __webpack_public_path__ + "assets/nono.d8e4699f.png";